import React from 'react';

import SearchTypeahead from '../../components/SearchTypeahead';

const SearchSection = () => {
  const changePageURL = (apps) => {
    window.location.assign(
      `/apps/${apps[0].store}/${apps[0].ref_no}`,
    );
  };

  return (
    <div className="bg-gray b-rds card-simple m-b">
      <h1
        className="text-xl text-normal text-xxs-center"
        style={{ marginBottom: 26 }}
      >
      Find an app to get insights
      </h1>
      <SearchTypeahead
        placeholder="Search for any app..."
        bsSize="lg"
        className="app-insights-search"
        limit={6}
        onChange={changePageURL}
      />
    </div>
  );
};

export default SearchSection;
